<template>
     <SmallSquare content='列表显示消费者领取权益卡明细' ></SmallSquare>
     <a-card :bordered="false">
         <a-form class="m-t-10" layout='inline'>
         <a-form-item>
             <a-input-group compact :style="{width:'460px'}">
                 <a-select v-model:value="search.key_type" style="width:150px">
                     <a-select-option value="user_name">用户名称</a-select-option>
                      <a-select-option value="card_name">权益卡名称</a-select-option>
                       <a-select-option value="store_name">下单门店</a-select-option>
                        <a-select-option value="parent_name">门店所属上级</a-select-option>
                 </a-select>
                 <a-input type="text" style="width:60%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索"></a-input>
             </a-input-group>
         </a-form-item>
         <a-form-item label="领取时间">
            <a-range-picker v-model:value="time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changeData" />
         </a-form-item>
          <a-form-item >
              <a-button type="primary" @click="search.page=1;onSearch()">搜索</a-button>
          </a-form-item>
          <a-form-item >
              <a-button type="primary" ghost v-has:memberCardExport="()=>{exportTable()}">导出</a-button>
          </a-form-item>
     </a-form>
     <a-table :pagination='pagination' :loading='loading' bordered rowKey='create_time' :columns='columns' :data-source='list' class='tableFixBox m-t-20' :scroll="{ x: 'max-content'}" @change="changePage">
         <template v-slot:action="{record}">
            <a href="javaScript:;" class="s_c376" v-has:seeMemberInfo="()=>{seeMemberInfo(record)}">查看信息</a>
         </template>
     </a-table>
     </a-card>
     <a-modal :keyboard="false" title="资料收集" v-model:visible="showInfo" centered :width='500' :footer="null" destroyOnClose>
         <div class="p-l-20" v-if="collectUser.is_collect_user_info==1">
              <div>姓名：{{collectUser.user.real_name || '无'}}</div>
              <div class="m-t-20">手机号：{{collectUser.user.mobile ||'无'}}</div>
              <div class="m-t-20">生日：{{collectUser.user.birthday || '无'}}</div>
              <div class="m-t-20">性别：{{collectUser.user.sex || '保密'}}</div>
              <div class="m-t-20">地区：{{collectUser.user.area || '无'}}</div>
         </div>
         <div class="p-l-20 fz-16" style="height:180px" v-else>暂无收集资料</div>
     </a-modal>
</template>

<script>
  import { receiveList } from "@/api/assets";
import { toRefs,reactive,ref, onMounted } from 'vue'
 import { iscode } from "@/utils/app";
  import { message } from "ant-design-vue";
const columns = [
    {
        title: "用户名称",
        dataIndex: "member_name",
         fixed: "left"
    },
    {
        title: "权益卡名称",
        dataIndex: "card_name",
         customRender:({record})=>{
            return record.card_name || '-'
        },
        width:140,
    },
    {
        title: "有效期",
        dataIndex: "expiry_date",
        width:120,
        customRender:({record})=>{
            return record.expiry_date?record.expiry_date+ '月':'-';
        }
    },
    {
        title: "领取时间",
        dataIndex: "create_time",
    },
     {
        title: "领取方式",
        dataIndex: "source_type",
        width:140,
    },
     {
        title: "下单门店",
        dataIndex: "store_name",
        width:200,
    },
    {
        title: "门店所属上级",
        dataIndex: "parent_name",
         width:200,
    },
     {
        title: "操作",
        dataIndex: "7",
        width:120,
        fixed: "right",
        slots: { customRender: "action" },
    }
]
export default{
    setup(){
        const search = ref({
            key_type:'user_name',
            keyword:'',
             start_time: "",
              end_time: "", 
              page: 1,
              limit: 10,
        })
        const state = reactive({
            time:[],
            loading:false,
            list:[],
             pagination:{ //分页
              total:0,
              current:1,
              pageSize:10,
               defaultPageSize:10,
               showSizeChanger:true, 
               pageSizeOptions:['5','10', '20', '30', '40', '50'], 
               showQuickJumper:true, 
               showTotal:(total)=> `共 ${total} 条`
             },
             showInfo:false,
             collectUser:{}
        })
        const methods= {
            changeData(e){
                search.value.start_time = e[0];
                search.value.end_time = e[1];
            },
            changePage(e){
                 state.pagination.pageSize = e.pageSize;
                 state.pagination.current = e.current;
                 search.value.limit = e.pageSize;
                 search.value.page = e.current;
                 methods.onSearch()
            },
            seeMemberInfo(record){
                console.log(record)
                state.collectUser = record;
                state.showInfo = true;
            },
       async exportTable(){
               const hide = message.loading('正在加载中...', 0);
               let result = await receiveList({...search.value,excel:1}).then(res=>res.data).catch(error=>error);
               if(iscode(result,true)){
                //  window.open(config.onlineOrderUrl[process.env.VUE_APP_type]+'download?key='+result.data.key)
                console.log(1)
               }
               setTimeout(hide);
             },
            async onSearch(){
                state.loading = true;
                state.list = [];
                let result = await receiveList({...search.value}).then(res=>res.data) 
                state.loading = false;
                if(iscode(result)){
                    state.list = result.data.data;
                    state.pagination.total = result.data.total;
                }else{
                    message.error(result.msg)
                }
             }
        }

        onMounted(()=>{
            methods.onSearch()
        })
        return{
            ...toRefs(state),
            search,
            ...methods,
            columns
        }
    }
}
</script>
